// removed by extract-text-webpack-plugin
module.exports = {"button":"c-IconButton__button","big":"c-IconButton__big"};